import {debounce} from "debounce";
import ErrorPopupEvent from "../model/ErrorPopupEvent";

export default (vueObject, mutation, eventHandler) => {
    const event = new ErrorPopupEvent(mutation, null);

    if ((mutation.type === 'error/push' || mutation.type === 'errorPush') && mutation.payload) {
        event.message = errorToMessage(mutation.payload, mutation);
        if (mutation.payload instanceof Error){
            event._errors = [mutation.payload];

            if (eventHandler){
                eventHandler(event);
            }

            if (event.show){
                reportError(event.message, vueObject);
            }

            return;
        }

        let errorCategoryKey = mutation?.payload?.extensions?.category;
        if (!errorCategoryKey) errorCategoryKey = mutation?.payload?.graphQLErrors?.[0]?.extensions?.category;

        if (!errorCategoryKey){
            return;
        }

        event._isValidationError = errorCategoryKey === 'arguments_validation_error';

        let message = '', errors = [];

        // validation errors
        if (event._isValidationError){
            errors = mutation?.payload?.graphQLErrors;
            if (!errors){
                errors = mutation?.payload ? [mutation?.payload] : [];
            }

            if (errors && errors.length){
                errors.forEach(error => {
                    message += errorToMessage(error);
                });
            }

            // other non-internal errors (eg: authorization)
        }else if(errorCategoryKey && errorCategoryKey !== "internal"){
            message = mutation?.payload?.message;
        }

        if (!message){
            message = vueObject.$ucfirst(vueObject.$t('general.generalError', {catalog: 'app_mobile'}));
        }

        event._errors = errors;
        event.message = message;

        if (eventHandler){
            eventHandler(event);
        }

        if (event.show){
            reportError(event.message, vueObject);
        }
    }
};

const reportError = debounce((message, vueObject) => {
    vueObject.$toasted.show(message, {
        type : 'error',
        icon : 'error_outline',
        position: 'bottom-center',
        duration : 10000
    });
}, 2000, true);

function errorToMessage(error, mutation){
    const messages = [];

    if (error?.extensions?.validation){
        addValidationToMessages(error.extensions.validation, messages)
    }else if (error.graphQLErrors){
        error.graphQLErrors.forEach(subError => {
            if (subError?.extensions?.validation){
                addValidationToMessages(subError.extensions.validation, messages)
            }
        })
    }else if (mutation?.payload?.message){
        messages.push(mutation.payload.message)
    }

    return messages.join('');
}

function addValidationToMessages(validation, messages){
    for (let field in validation){
        validation[field].forEach(fieldError => {
            messages.push(`${field}: ${fieldError.message}`);
        })
    }
}